"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRelSeoUrl = exports.checkIsSeo = void 0;
var color_1 = require("../api/color");
var getGlobalWindow_1 = require("../tools/getGlobalWindow");
var getUrlParam_1 = require("../tools/getUrlParam");
var searchParam_1 = require("../tools/searchParam");
var seoLocationWatcher_1 = require("./seoLocationWatcher");
var checkIsSeoSave = {
    isSeo: undefined,
    req: undefined,
};
// 检查地址是否是seo的地址
function checkIsSeo(currentUrl, forceUpdate) {
    if (forceUpdate === void 0) { forceUpdate = false; }
    return __awaiter(this, void 0, void 0, function () {
        var wd, res, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    wd = (0, getGlobalWindow_1.getWindow)();
                    currentUrl = currentUrl || wd.location.href;
                    if (!forceUpdate && checkIsSeoSave.isSeo !== undefined) {
                        if (currentUrl === null || currentUrl === void 0 ? void 0 : currentUrl.includes("healthjd.com")) {
                            checkIsSeoSave.isSeo = false;
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, checkIsSeoSave.isSeo];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, color_1.isSeoUrlInfo)({
                            currentUrl: currentUrl,
                        })];
                case 2:
                    res = _a.sent();
                    res = res || {};
                    console.log(111, "checkIsSeo", res === null || res === void 0 ? void 0 : res.data);
                    checkIsSeoSave.isSeo = (res === null || res === void 0 ? void 0 : res.data) || false;
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    checkIsSeoSave.isSeo = false;
                    console.log(111, "checkIsSeo", e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, checkIsSeoSave.isSeo];
            }
        });
    });
}
exports.checkIsSeo = checkIsSeo;
// 通过原始（互医）的地址，获取到对应的seo地址
function getRelSeoUrl(sourceUrl, currentUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var wd, isSeoReq, isSeo, realSeoUrl, res, params, params1, p1, str, e_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!sourceUrl) {
                        return [2 /*return*/, sourceUrl];
                    }
                    wd = (0, getGlobalWindow_1.getWindow)();
                    currentUrl = currentUrl || wd.location.href;
                    isSeoReq = checkIsSeoSave.req;
                    if (!isSeoReq) {
                        isSeoReq = checkIsSeo(currentUrl);
                        checkIsSeoSave.req = isSeoReq;
                    }
                    return [4 /*yield*/, isSeoReq];
                case 1:
                    isSeo = _b.sent();
                    if (!isSeo) {
                        return [2 /*return*/, sourceUrl];
                    }
                    realSeoUrl = sourceUrl;
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, (0, color_1.queryMappingSeoUrlInfo)({
                            currentUrl: currentUrl,
                            sourceUrl: sourceUrl,
                        })];
                case 3:
                    res = _b.sent();
                    res = res || {};
                    console.log(111, "getRelSeoUrl", res === null || res === void 0 ? void 0 : res.data);
                    realSeoUrl = (res === null || res === void 0 ? void 0 : res.data) && (res === null || res === void 0 ? void 0 : res.data.seoUrl) ? res.data.seoUrl : sourceUrl;
                    params = (0, getUrlParam_1.getUrlParam)(realSeoUrl);
                    params1 = (0, getUrlParam_1.getUrlParam)(sourceUrl);
                    Object.assign(params, params1, (_a = {}, _a[seoLocationWatcher_1.isFromSeoKey] = true, _a));
                    p1 = realSeoUrl.split("?")[0];
                    str = p1;
                    if (Object.keys(params).length) {
                        str = "".concat(p1, "?").concat((0, searchParam_1.searchParam)(params));
                    }
                    realSeoUrl = str;
                    return [3 /*break*/, 5];
                case 4:
                    e_2 = _b.sent();
                    console.log(111, "getRelSeoUrl", e_2);
                    return [3 /*break*/, 5];
                case 5:
                    console.log(111, "getRelSeoUrl", sourceUrl, realSeoUrl);
                    return [2 /*return*/, realSeoUrl];
            }
        });
    });
}
exports.getRelSeoUrl = getRelSeoUrl;
